module.exports = __webpack_public_path__ + "static/media/icon_presentation.ef063f17.png";